var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1031Etage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: -1,
    width: 355.725,
    height: 355.725,
    id: "canvas_background",
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("rect", {
    fill: "#e3e8ee",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 45.836,
    y: 386.802,
    width: 229.485,
    height: 52.593,
    id: "svg_26",
    transform: "rotate(24 160.57804870605497,413.0986022949218)",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#e3e8ee",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 229.924,
    y: 386.384,
    width: 229.485,
    height: 51.426,
    id: "svg_27",
    transform: "rotate(-25 344.66613769531216,412.09716796874994)",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#e3e8ee",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 52.075,
    y: 333.977,
    width: 134.01,
    height: 41.998,
    id: "svg_28",
    transform: "rotate(-22 119.07974243164048,354.9759826660156)",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#e3e8ee",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 133.111,
    y: 342.301,
    width: 160.215,
    height: 85.261,
    id: "svg_30",
    transform: "rotate(-152 213.2183380126953,384.9315185546875)",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#e3e8ee",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 214.663,
    y: 346.333,
    width: 160.215,
    height: 68.482,
    id: "svg_29",
    transform: "rotate(-25 294.76989746093733,380.57427978515625)",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#e3e8ee",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 335.996,
    y: 337.114,
    width: 134.01,
    height: 41.998,
    id: "svg_31",
    transform: "rotate(-158 403.0012817382813,358.1132202148438)",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#e3e8ee",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 452.732,
    y: 362.753,
    width: 28.323,
    height: 24.963,
    id: "svg_32",
    transform: "rotate(-158 466.8937377929687,375.2343139648438)",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#e3e8ee",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 32.452,
    y: 362.963,
    width: 25.26,
    height: 24.963,
    id: "svg_33",
    transform: "rotate(-158 45.081592559814446,375.44488525390625)",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m506.306997,367.35416l-104.032,-42.385c-4.674,-1.904 -10.011,0.34 -11.915,5.018c-1.906,4.676 0.341,10.011 5.018,11.916l84.146,34.284l-223.524,99.343l-223.523,-99.343l81.909,-33.372c4.676,-1.906 6.924,-7.241 5.018,-11.918c-1.902,-4.676 -7.239,-6.919 -11.915,-5.018l-101.796,41.475c-3.395,1.383 -5.636,4.659 -5.692,8.324c-0.058,3.664 2.078,7.009 5.426,8.498l246.858,109.715c1.183,0.526 2.449,0.788 3.714,0.788c1.266,0 2.531,-0.262 3.714,-0.788l246.858,-109.715c3.348,-1.489 5.484,-4.834 5.426,-8.498c-0.054,-3.665 -2.295,-6.941 -5.69,-8.324z",
    id: "svg_24",
    fill: "#193351"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_1"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#e3e8ee",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 371.959,
    y: 327.415,
    width: 40.561,
    height: 123.171,
    id: "svg_50",
    transform: "rotate(-126 392.23910522460943,388.99887084960943)",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#e3e8ee",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 222.988,
    y: 338.995,
    width: 160.215,
    height: 110.741,
    id: "svg_43",
    transform: "rotate(-25 303.09509277343744,394.36407470703125)",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#e3e8ee",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 126.246,
    y: 277.386,
    width: 41.945,
    height: 123.171,
    id: "svg_46",
    transform: "rotate(-117 147.21900939941406,338.9714050292969)",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#e3e8ee",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 130.439,
    y: 299.779,
    width: 160.215,
    height: 110.741,
    id: "svg_44",
    transform: "rotate(-25 210.54606628417963,355.14913940429693)",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#e3e8ee",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 37.054,
    y: 354.7,
    width: 32.566,
    height: 35.569,
    id: "svg_47",
    transform: "rotate(-140 53.336673736572294,372.4834594726563)",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#e3e8ee",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 54.463,
    y: 386.018,
    width: 229.485,
    height: 52.593,
    id: "svg_42",
    transform: "rotate(24 169.2054901123047,412.3123474121093)",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#e3e8ee",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 274.998,
    y: 256.883,
    width: 88.926,
    height: 183.007,
    id: "svg_45",
    transform: "rotate(-67 319.4615173339843,348.38604736328125)",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#e3e8ee",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 407.795,
    y: 329.77,
    width: 24.711,
    height: 123.171,
    id: "svg_49",
    transform: "rotate(-117 420.1506958007812,391.3542175292969)",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m506.306997,366.410833l-246.858,-100.572c-2.21,-0.9 -4.688,-0.9 -6.897,0l-246.859,100.572c-3.395,1.384 -5.636,4.66 -5.692,8.325c-0.058,3.664 2.078,7.009 5.426,8.498l246.858,109.715c1.183,0.526 2.449,0.788 3.714,0.788c1.266,0 2.531,-0.262 3.714,-0.788l246.858,-109.715c3.348,-1.489 5.484,-4.834 5.426,-8.498c-0.054,-3.665 -2.295,-6.941 -5.69,-8.325zm-250.307,108.177l-223.523,-99.343l223.523,-91.065l223.523,91.065l-223.523,99.343z",
    id: "svg_3",
    fill: "#193351"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1031Etage);
export default __webpack_public_path__ + "static/media/103 1 Etage.cd7985e3ea0a6206517017cd523cb829.svg";
export { ForwardRef as ReactComponent };